var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.347,
    height: 14.036,
    viewBox: "0 0 50.347 14.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12770",
    "data-name": "Grupo 12770",
    transform: "translate(-241.977 -365.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12745",
    "data-name": "Grupo 12745",
    transform: "translate(247.025 368.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12758",
    "data-name": "Grupo 12758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1156",
    "data-name": "Trazado 1156",
    d: "M9.813,8.5a1,1,0,0,1-.862-1.507c-.04-.012-.087-.023-.141-.035a3.427,3.427,0,0,0-2.317.355,1,1,0,0,1-.972-1.748A5.447,5.447,0,0,1,9.214,5a2.459,2.459,0,0,1,1.6.941,1.775,1.775,0,0,1,.249,1.469,1.532,1.532,0,0,1-.833,1,.991.991,0,0,1-.415.091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1158",
    "data-name": "Trazado 1158",
    d: "M28.256,9.22a1.015,1.015,0,0,1-.331-.057A1.854,1.854,0,0,1,26.5,7.693a1.661,1.661,0,0,1,.337-1.221,2.8,2.8,0,0,1,2.389-.894,20.15,20.15,0,0,1,4.808.691A1,1,0,1,1,33.514,8.2a18.175,18.175,0,0,0-4.331-.623c-.059,0-.111,0-.161,0a1,1,0,0,1-.766,1.644"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_1",
    "data-name": "Sustracci\\xF3n 1",
    d: "M-7749.852-5257.965h-2.171a.974.974,0,0,1,.1-.43,20.646,20.646,0,0,1,3.983-5.519,25.461,25.461,0,0,1,5.774-4.3,31.823,31.823,0,0,1,15.317-3.79,31.835,31.835,0,0,1,15.317,3.79,25.49,25.49,0,0,1,5.774,4.3,20.645,20.645,0,0,1,3.981,5.519.974.974,0,0,1,.1.429h-2.173a21.061,21.061,0,0,0-8.693-8.5,29.74,29.74,0,0,0-14.307-3.53,29.756,29.756,0,0,0-14.309,3.53,21.084,21.084,0,0,0-8.693,8.5Z",
    transform: "translate(7994 5637.965)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_880",
    "data-name": "Elipse 880",
    transform: "translate(263 370)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 1,
    rx: 4,
    ry: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 1,
    rx: 3.5,
    ry: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moonIcon.3cccafacffd41faffa20a54f719b4435.svg";
export { ForwardRef as ReactComponent };